import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { AnyAction } from 'redux';
import { GROUP_TYPE } from '~/Api/User/ProductGroup';
import { handleError } from '~/ErrorHandler';
import { flashSuccessMessage, flashWarningMessage } from '~/FlashMessage';
import { createGroup, redirectToGroup } from '~/ProductGroup';
import type { ThunkDispatch } from '~/Store';

import { FiltersValue } from '../components/Filters';
import { buildSuklCodesFromGroups } from '../utils/buildSuklCodesFromGroups';
import { fetchAllFilteredAvailabilityGroups } from '../utils/fetchAllFilteredAvailabilityGroups';

export function useAvailabilityCreateFolder(filters: FiltersValue) {
	const dispatch: ThunkDispatch<AnyAction> = useDispatch();
	const [isCreating, setIsCreating] = useState(false);
	const [isDialogOpen, setIsDialogOpen] = useState(false);

	const hasActiveFilter = filters.items.length > 0 || filters.rs.length > 0;

	const openCreateFolderDialog = () => {
		if (hasActiveFilter && !isCreating) {
			setIsDialogOpen(true);
		}
	};

	const closeCreateFolderDialog = () => {
		if (!isCreating) {
			setIsDialogOpen(false);
		}
	};

	const handleCreateFolder = async (name: string) => {
		if (!hasActiveFilter || isCreating) {
			return;
		}

		setIsCreating(true);

		try {
			const groups = await fetchAllFilteredAvailabilityGroups(filters);
			const lists = buildSuklCodesFromGroups(groups);

			if (lists.length === 0) {
				dispatch(flashWarningMessage('Ve filtrovaných výsledcích nejsou žádné SÚKL kódy pro vytvoření složky.'));
				return;
			}

			const { productGroup } = await dispatch(createGroup(name, GROUP_TYPE, null, null, null, lists));

			setIsDialogOpen(false);
			dispatch(flashSuccessMessage(`Složka ${name} byla vytvořena.`));
			dispatch(redirectToGroup(productGroup));
		} catch (error: unknown) {
			dispatch(handleError(error));
		} finally {
			setIsCreating(false);
		}
	};

	return {
		isDialogOpen,
		openCreateFolderDialog,
		closeCreateFolderDialog,
		handleCreateFolder,
		isCreating,
		hasActiveFilter,
	};
}
